import { render, staticRenderFns } from "./ToSAsterika.vue?vue&type=template&id=d5bea68a"
import script from "./ToSAsterika.vue?vue&type=script&lang=js"
export * from "./ToSAsterika.vue?vue&type=script&lang=js"
import style0 from "./ToSAsterika.vue?vue&type=style&index=0&id=d5bea68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports